var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.prototype.isBehindProxy = function () {
        var proxyHeader = "via";
        var req = new XMLHttpRequest();
        req.open("GET", document.location, false);
        req.send();
        var header = req.getResponseHeader(proxyHeader);
        if (header) {
            // we are on a proxy
            return true;
        }
        return false;
    };
    Utils.prototype.extractUrlValue = function (key, url) {
        if (typeof url === "undefined")
            url = "";
        var match = url.match("[?&]" + key + "=([^&]+)");
        return match ? match[1] : null;
    };
    return Utils;
}());
var utils = new Utils();
export default utils;
export var logResults = function (logMessage, result) {
    logMessage(result);
    if (result.localRouting && !result.localRouting.includes("udp")) {
        logMessage("Session wasn't conducted over UDP", "red");
        result.meta = {
            errorsCount: 1,
        };
    }
};
// Can make more advance by accept setup like moduel1,module2
export var getLogVerboseLevel = function (verbose, moduleName) {
    return verbose === "true" || verbose === "all" || verbose === moduleName;
};
//# sourceMappingURL=utils.js.map